import type { ReactNode } from 'react';
import type { ComparisonTheme } from './comparisonVisualThemes';

export interface FeatureSectionProps {
  id?: string;
  title: string;
  eyebrow?: string;
  children: ReactNode;
  variant?: 'white' | 'muted' | 'dark';
  theme?: ComparisonTheme;
}

export default function FeatureSection({
  id,
  title,
  eyebrow,
  children,
  variant = 'white',
  theme,
}: FeatureSectionProps) {
  const primary = theme?.primary ?? '#1769ff';
  const bg =
    variant === 'muted'
      ? 'bg-slate-50'
      : variant === 'dark'
        ? 'bg-slate-900 text-white'
        : 'bg-white';
  const titleClass = variant === 'dark' ? 'text-white' : 'text-slate-900';
  const eyebrowClass = variant === 'dark' ? 'text-white/70' : '';

  return (
    <section id={id} className={`py-16 lg:py-20 ${bg}`}>
      <div className="max-w-5xl mx-auto px-6">
        {eyebrow ? (
          <p
            className={`text-[11px] font-bold uppercase tracking-[0.2em] mb-3 ${eyebrowClass}`}
            style={variant !== 'dark' ? { color: primary } : undefined}
          >
            {eyebrow}
          </p>
        ) : null}
        <h2 className={`text-2xl lg:text-3xl font-bold tracking-tight mb-10 ${titleClass}`}>{title}</h2>
        <div
          className={`max-w-none leading-relaxed ${
            variant === 'dark' ? 'text-slate-300' : 'text-slate-600'
          } prose prose-slate max-w-none`}
        >
          {children}
        </div>
      </div>
    </section>
  );
}
